module.exports = "pegasus/assets/x_white.png";